"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnershipHistoryInputSchema = exports.PartnershipHistoryResponseSchema = exports.PartnershipHistorySchema = void 0;
var zod_1 = require("zod");
/**
 * 외부제휴 프로모션 참여 이력 데이터
 */
exports.PartnershipHistorySchema = zod_1.z.object({
    policyCode: zod_1.z.string(),
    companyName: zod_1.z.string(),
    redeemCode: zod_1.z.string(),
    couponTitle: zod_1.z.string(),
    couponSubTitle: zod_1.z.string(),
    expireDate: zod_1.z.string(),
    isExpired: zod_1.z.boolean().optional(),
    logoImageUrl: zod_1.z.string(),
    buttonTitle: zod_1.z.string(),
    buttonUrl: zod_1.z.string(),
    cautionText: zod_1.z.string().optional(),
    distributedAt: zod_1.z.string(),
});
/**
 * 외부제휴 프로모션 참여 이력 데이터
 */
exports.PartnershipHistoryResponseSchema = zod_1.z.object({
    totalElements: zod_1.z.number(),
    totalPages: zod_1.z.number(),
    page: zod_1.z.number().optional(),
    last: zod_1.z.boolean(),
    content: zod_1.z.array(exports.PartnershipHistorySchema),
});
exports.PartnershipHistoryInputSchema = zod_1.z.object({
    page: zod_1.z.number().optional(),
    size: zod_1.z.number().optional(),
});
